import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Box from "../../../components/Box";
import { Helpers } from "../../../helpers/Helpers";
import { AddConstantResponse } from "../../../models/response/constant/AddConstantResponse";
import { storeActivityIndicator } from "../../../redux/reducers/authSlice";
import { ConstantService } from "../../../services/ConstantService";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import toast from "react-hot-toast";
import { GetConstantListResponse, GetConstantListResponseItem } from "../../../models/response/constant/GetConstantListResponse";
import { useNavigate, useSearchParams } from "react-router-dom";
import PageHeader from "../../../components/PageHeader";
import { AddCompanyRequest } from "../../../models/request/company/AddCompanyRequest";
import { CompanyService } from "../../../services/CompanyService";
import { AddCompanyResponse } from "../../../models/response/company/AddCompanyResponse";
import { GetCompanyByIdResponse, GetCompanyByIdResponseCompanyAddress, GetCompanyByIdResponseCompanyAuthorizedPerson, GetCompanyByIdResponseCompanyBank, GetCompanyByIdResponseFileArchive } from "../../../models/response/company/GetCompanyByIdResponse";
import { useMask } from "@react-input/mask";
import GeneralInformation from "./Components/GeneralInformation";
import CompanyTypeInformation from "./Components/CompanyTypeInformation";
import { CustomSingleSelectModel } from "../../../components/CustomSingleSelect";
import AccountingInformation from "./Components/AccountingInformation";
import AddressInformation from "./Components/AddressInformation";
import AuthorizedPersonsInformations from "./Components/AuthorizedPersonsInformations";
import BanksInformations from "./Components/BanksInformations";
import FileArchives from "./Components/FileArchives";
import { RootState } from "../../../redux/store";

const CompanyAdd = () => {
    const auth = useSelector((state: RootState) => state.auth)
    const navigate = useNavigate();
    const pageName = "Ön Muhasebe > Tanımlamalar > Firma Tanımları"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();
    const generalInformationRef: any = useRef();
    const companyTypeInformationRef: any = useRef();
    const accountingInformationRef: any = useRef();
    const addressInformationRef: any = useRef();
    const authorizedPersonsInformationsRef: any = useRef();
    const banksInformationsRef: any = useRef();
    const fileArchivesRef: any = useRef();

    const [companyId, setCompanyId] = useState<string | undefined>(undefined);

    // GENEL BİLGİLER
    const [code, setCode] = useState<string | undefined>(undefined);
    const [name, setName] = useState<string | undefined>(undefined);
    const [longName, setLongName] = useState<string | undefined>(undefined);
    const phone1Ref = useMask({ mask: '(___) ___-__-__', replacement: { _: /\d/ } });
    const [phone1, setPhone1] = useState<string | undefined>(undefined);
    const [email, setEmail] = useState<string | undefined>(undefined);
    const [desc, setDesc] = useState<string | undefined>(undefined);
    const [isBlocked, setIsBlocked] = useState(false);
    const [blockedDesc, setBlockedDesc] = useState<string | undefined>(undefined);
    const [isCustomActive, setIsCustomActive] = useState(true);
    const fileRef: any = useRef();
    const [file, setFile] = useState<File | undefined>(undefined);
    const [b64, setB64] = useState(Helpers.getPlaceholder());

    // FİRMA TÜRÜ BİLGİLERİ
    const [isCustomer, setIsCustomer] = useState(false);
    const [customerIntegrationCode, setCustomerIntegrationCode] = useState<string | undefined>(undefined);
    const [isSupplier, setIsSupplier] = useState(false);
    const [supplierIntegrationCode, setSupplierIntegrationCode] = useState<string | undefined>(undefined);
    const [isAgency, setIsAgency] = useState(false);
    const [agencyIntegrationCode, setAgencyIntegrationCode] = useState<string | undefined>(undefined);
    const [isSenderFirm, setIsSenderFirm] = useState(false);
    const [senderFirmIntegrationCode, setSenderFirmIntegrationCode] = useState<string | undefined>(undefined);
    const [isReceiverFirm, setIsReceiverFirm] = useState(false);
    const [receiverFirmIntegrationCode, setReceiverFirmIntegrationCode] = useState<string | undefined>(undefined);
    const [isDutyFirm, setIsDutyFirm] = useState(false);
    const [isAirlineFirm, setIsAirlineFirm] = useState(false);
    const [isSeawayFirm, setIsSeawayFirm] = useState(false);
    const [isCompany, setIsCompany] = useState(auth.user.user?.data.isAdmin ?? false);
    const [selectedInitialCompanyType, setSelectedInitialCompanyType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [isRepresentative, setIsRepresentative] = useState(false);
    const [isInsuranceFirm, setIsInsuranceFirm] = useState(false);

    // MUHASEBE BİLGİLERİ
    const [selectedCommercialType, setSelectedCommercialType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [tckn, setTckn] = useState<string | undefined>(undefined);
    const [vkn, setVkn] = useState<string | undefined>(undefined);
    const [taxOffice, setTaxOffice] = useState<string | undefined>(undefined);
    const [selectedPaymentType, setSelectedPaymentType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedMaturityPeriod, setSelectedMaturityPeriod] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedInvoiceCurrencyType, setSelectedInvoiceCurrencyType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedEArchiveType, setSelectedEArchiveType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedEArchiveSendType, setSelectedEArchiveSendType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [abnNumber, setAbnNumber] = useState<string | undefined>(undefined);
    const [mernisNo, setMernisNo] = useState<string | undefined>(undefined);

    // ADRES BİLGİLERİ
    const [companyAddresses, setCompanyAddresses] = useState<GetCompanyByIdResponseCompanyAddress[]>([]);

    // YETKİLİ KİŞİ BİLGİLERİ
    const [companyAuthorizedPersons, setCompanyAuthorizedPersons] = useState<GetCompanyByIdResponseCompanyAuthorizedPerson[]>([]);

    // BANKA BİLGİLERİ
    const [companyBanks, setCompanyBanks] = useState<GetCompanyByIdResponseCompanyBank[]>([]);

    // DOSYA ARŞİV
    const [fileArchives, setFileArchives] = useState<GetCompanyByIdResponseFileArchive[]>([]);

    const [canBeEdited, setCanBeEdited] = useState(false);

    const [isWithholding, setIsWithholding] = useState<boolean>(false);

    const handleFileRead = async (event: any, setFunction: React.Dispatch<React.SetStateAction<string>>) => {
        try {
            const file = event.target.files[0]
            const base64: any = await convertBase64(file)
            setFunction(base64);
        } catch (error) {
            setFunction(Helpers.getPlaceholder())
        }
    }

    const convertBase64 = (file: any) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file)
            fileReader.onload = () => {
                resolve(fileReader.result);
            }
            fileReader.onerror = (error) => {
                reject(error);
            }
        })
    }

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            if (id) {
                var response: GetCompanyByIdResponse = await CompanyService.getCompanyById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setCanBeEdited(auth.user.user?.data.isAdmin || id != auth.selectedCompany?.companyId);

                setCompanyId(response.data.companyId);
                setCode(response.data.code);
                setName(response.data.name);
                setLongName(response.data.longName);
                setDesc(response.data.description);
                setIsCustomActive(response.data.isCustomActive);
                setPhone1(response.data.phone1);
                setEmail(response.data.email);
                setIsBlocked(response.data.isBlocked);
                setBlockedDesc(response.data.blockedDescription);
                setB64(Helpers.isEmpty(response.data.logo) ? Helpers.getPlaceholder() : response.data.logo)
                setIsCustomer(response.data.isCustomer);
                setIsRepresentative(response.data.isRepresentative);
                setIsInsuranceFirm(!!response.data.isInsuranceFirm);
                setCustomerIntegrationCode(response.data.customerIntegrationCode);
                setIsSupplier(response.data.isSupplier);
                setSupplierIntegrationCode(response.data.supplierIntegrationCode);
                setIsAgency(response.data.isAgency);
                setAgencyIntegrationCode(response.data.agencyIntegrationCode);
                setIsSenderFirm(response.data.isSenderFirm);
                setIsReceiverFirm(response.data.isReceiverFirm);
                setIsDutyFirm(response.data.isDutyFirm);
                setIsAirlineFirm(response.data.isAirlineFirm);
                setIsSeawayFirm(response.data.isSeawayFirm);
                setIsCompany(response.data.isCompany);
                setIsWithholding(response.data.isWithholding);

                if (response.data.commercialTypeId)
                    setSelectedCommercialType({ label: response.data.commercialTypeName, value: response.data.commercialTypeId, additionalValue1: response.data.commercialTypeKey });

                setTckn(response.data.tckn);
                setVkn(response.data.vkn);
                setTaxOffice(response.data.taxOffice);

                if (response.data.paymentTypeId)
                    setSelectedPaymentType({ label: response.data.paymentTypeName, value: response.data.paymentTypeId, additionalValue1: response.data.paymentTypeKey });

                if (response.data.initialCompanyTypeId)
                    setSelectedInitialCompanyType({ label: response.data.initialCompanyTypeName, value: response.data.initialCompanyTypeId });

                if (response.data.maturityPeriodId)
                    setSelectedMaturityPeriod({ label: response.data.maturityPeriodName, value: response.data.maturityPeriodId, additionalValue1: response.data.maturityPeriodKey });

                if (response.data.invoiceCurrencyTypeId)
                    setSelectedInvoiceCurrencyType({ label: response.data.invoiceCurrencyTypeName, value: response.data.invoiceCurrencyTypeId });

                if (response.data.eArchiveTypeId)
                    setSelectedEArchiveType({ label: response.data.eArchiveTypeName, value: response.data.eArchiveTypeId });

                if (response.data.eArchiveSendTypeId)
                    setSelectedEArchiveSendType({ label: response.data.eArchiveSendTypeName, value: response.data.eArchiveSendTypeId });

                setAbnNumber(response.data.abnNumber);
                setMernisNo(response.data.mernisNo);

                setCompanyAddresses(response.data.companyAddresses);
                setCompanyAuthorizedPersons(response.data.companyAuthorizedPersons);
                setCompanyBanks(response.data.companyBanks);
                setFileArchives(response.data.fileArchives);

                setSenderFirmIntegrationCode(response.data.senderFirmIntegrationCode);
                setReceiverFirmIntegrationCode(response.data.receiverFirmIntegrationCode);
            }
            else {
                setCanBeEdited(true)

                var response5: GetConstantListResponse = await ConstantService.getConstantList('MEETING_COMPANY_TYPE', undefined, "3");

                if (!response5.isSuccess) {
                    toast.error(response5.message)
                    return;
                }

                if (response5.data.length > 0) {
                    setSelectedInitialCompanyType({ label: response5.data[0].value + '', value: response5.data[0].constantId, additionalValue1: response5.data[0].additionalValue1 });
                }
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const saveCompany = async () => {
        try {
            if (Helpers.isEmpty(name))
                toast.error('Kısa Ad alanını doldurunuz!')
            else if (Helpers.isEmpty(longName))
                toast.error('Fatura Ünvanı alanını doldurunuz!')
            else if ((!Helpers.isEmpty(phone1) && phone1 && phone1.length < 15))
                toast.error('Lütfen geçerli bir telefon numarası giriniz!')
            else if (!Helpers.isEmpty(email) && email && !Helpers.validateEmail(email))
                toast.error('Lütfen geçerli bir email adresi giriniz!')
            else if (!isRepresentative && !isCustomer && !isSupplier && !isAgency && !isSenderFirm && !isReceiverFirm && !isDutyFirm && !isAirlineFirm && !isSeawayFirm && !isCompany && !isInsuranceFirm)
                toast.error('Lütfen Firma Türü alanından en az bir seçim yapınız!')
            else if (isCustomer && !selectedCommercialType)
                toast.error('Ticari Türü alanını doldurunuz!')
            else if (selectedCommercialType && selectedCommercialType?.additionalValue1 == "1" && !Helpers.validateTckn(tckn))
                toast.error('Lütfen geçerli bir TC Kimlik No giriniz!')
            else if (selectedCommercialType && selectedCommercialType?.additionalValue1 == "2" && !Helpers.validateVkn(vkn))
                toast.error('Lütfen geçerli bir Vergi Kimlik No giriniz!')
            else if (isCustomer && Helpers.isEmpty(taxOffice))
                toast.error('Lütfen Vergi Dairesi alanını doldurunuz!')
            else if (selectedPaymentType && selectedPaymentType.additionalValue1 == "2" && !selectedMaturityPeriod)
                toast.error('Lütfen Vade Süresi alanını doldurunuz!')
            else if (!selectedInitialCompanyType)
                toast.error('Firma Durumu alanını doldurunuz!')
            else {
                dispatch(storeActivityIndicator(true));

                var obj: AddCompanyRequest = {
                    companyId: companyId,
                    blockedDescription: blockedDesc,
                    code: code,
                    companyLogo: file,
                    logo: (b64.startsWith("http") ? b64 : undefined),
                    description: desc,
                    email: email,
                    isBlocked: isBlocked ? 1 : 0,
                    isCustomActive: isCustomActive ? 1 : 0,
                    longName: longName,
                    name: name,
                    phone1: phone1,
                    agencyIntegrationCode: agencyIntegrationCode,
                    customerIntegrationCode: customerIntegrationCode,
                    isAgency: isAgency ? 1 : 0,
                    isAirlineFirm: isAirlineFirm ? 1 : 0,
                    isCustomer: isCustomer ? 1 : 0,
                    isDutyFirm: isDutyFirm ? 1 : 0,
                    isCompany: isCompany ? 1 : 0,
                    isReceiverFirm: isReceiverFirm ? 1 : 0,
                    receiverFirmIntegrationCode: receiverFirmIntegrationCode,
                    isSeawayFirm: isSeawayFirm ? 1 : 0,
                    isSenderFirm: isSenderFirm ? 1 : 0,
                    senderFirmIntegrationCode: senderFirmIntegrationCode,
                    isSupplier: isSupplier ? 1 : 0,
                    isRepresentative: isRepresentative ? 1 : 0,
                    isInsuranceFirm: isInsuranceFirm ? 1 : 0,
                    supplierIntegrationCode: supplierIntegrationCode,
                    abnNumber: abnNumber,
                    mernisNo: mernisNo,
                    commercialTypeId: selectedCommercialType?.value,
                    eArchiveSendTypeId: selectedEArchiveSendType?.value,
                    eArchiveTypeId: selectedEArchiveType?.value,
                    invoiceCurrencyTypeId: selectedInvoiceCurrencyType?.value,
                    maturityPeriodId: selectedMaturityPeriod?.value,
                    paymentTypeId: selectedPaymentType?.value,
                    taxOffice: taxOffice,
                    tckn: tckn,
                    vkn: vkn,
                    companyAddresses: companyAddresses.map(function (x) {
                        return {
                            addressText: x.addressText,
                            addressTypeId: x.addressTypeId,
                            districtId: x.districtId,
                            neighborhoodId: x.neighborhoodId,
                            isCustomActive: x.isCustomActive ? 1 : 0,
                            isDefault: x.isDefault ? 1 : 0,
                            postalCode: x.postalCode
                        }
                    }),
                    companyAuthorizedPersons: companyAuthorizedPersons.map(function (x) {
                        return {
                            departmentId: x.departmentId,
                            description: x.description,
                            isCustomActive: x.isCustomActive ? 1 : 0,
                            name: x.name,
                            phone1: x.phone1,
                            phone2: x.phone2,
                            surname: x.surname,
                            email: x.email
                        }
                    }),
                    companyBanks: companyBanks.map(function (x) {
                        return {
                            accountNo: x.accountNo,
                            bankId: x.bankId,
                            currencyTypeId: x.currencyTypeId,
                            iban: x.iban
                        }
                    }),
                    fileArchives: fileArchives.map(function (x) {
                        return {
                            description: x.description,
                            entityId: x.entityId,
                            file: x.fileArchiveFile,
                            fileName: x.fileName,
                            fileTypeId: x.fileTypeId,
                            fileArchiveId: x.fileArchiveId
                        }
                    }),
                    initialCompanyTypeId: selectedInitialCompanyType.value,
                    isWithholding: isWithholding ? 1 : 0
                }

                var response: AddCompanyResponse = await CompanyService.addCompany(obj);

                if (!response.isSuccess) {
                    toast.error(response.message);
                    dispatch(storeActivityIndicator(false));
                    return;
                }

                toast.success(response.message)

                dispatch(storeActivityIndicator(false));
                navigate(Helpers.getGoBackUrl())
            }
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <PageHeader
                        items={[
                            { text: 'Genel Bilgiler', ref: generalInformationRef },
                            { text: 'Firma Türü Bilgileri', ref: companyTypeInformationRef },
                            { text: 'Muhasebe Bilgileri', ref: accountingInformationRef },
                            { text: 'Adres Bilgileri', ref: addressInformationRef },
                            { text: 'Yetkili Kişi Bilgileri', ref: authorizedPersonsInformationsRef },
                            { text: 'Banka Bilgileri', ref: banksInformationsRef },
                            { text: 'Dijital Arşiv', ref: fileArchivesRef },
                        ]}
                    />

                    <GeneralInformation
                        b64={b64}
                        blockedDesc={blockedDesc}
                        code={code}
                        desc={desc}
                        email={email}
                        fileRef={fileRef}
                        generalInformationRef={generalInformationRef}
                        handleFileRead={handleFileRead}
                        isBlocked={isBlocked}
                        isCustomActive={isCustomActive}
                        longName={longName}
                        name={name}
                        phone1={phone1}
                        phone1Ref={phone1Ref}
                        setB64={setB64}
                        setBlockedDesc={setBlockedDesc}
                        setCode={setCode}
                        setDesc={setDesc}
                        setEmail={setEmail}
                        setFile={setFile}
                        setIsBlocked={setIsBlocked}
                        setIsCustomActive={setIsCustomActive}
                        setLongName={setLongName}
                        setName={setName}
                        setPhone1={setPhone1}
                        canBeEdited={canBeEdited}
                    />

                    <CompanyTypeInformation
                        agencyIntegrationCode={agencyIntegrationCode}
                        companyTypeInformationRef={companyTypeInformationRef}
                        customerIntegrationCode={customerIntegrationCode}
                        isAgency={isAgency}
                        isAirlineFirm={isAirlineFirm}
                        isCustomer={isCustomer}
                        isDutyFirm={isDutyFirm}
                        isCompany={isCompany}
                        isReceiverFirm={isReceiverFirm}
                        isSeawayFirm={isSeawayFirm}
                        isSenderFirm={isSenderFirm}
                        isSupplier={isSupplier}
                        setAgencyIntegrationCode={setAgencyIntegrationCode}
                        setCustomerIntegrationCode={setCustomerIntegrationCode}
                        setIsAgency={setIsAgency}
                        setIsAirlineFirm={setIsAirlineFirm}
                        setIsCustomer={setIsCustomer}
                        setIsDutyFirm={setIsDutyFirm}
                        setIsCompany={setIsCompany}
                        setIsReceiverFirm={setIsReceiverFirm}
                        setIsSeawayFirm={setIsSeawayFirm}
                        setIsSenderFirm={setIsSenderFirm}
                        setIsSupplier={setIsSupplier}
                        setSupplierIntegrationCode={setSupplierIntegrationCode}
                        supplierIntegrationCode={supplierIntegrationCode}
                        canBeEdited={canBeEdited}
                        selectedInitialCompanyType={selectedInitialCompanyType}
                        setSelectedInitialCompanyType={setSelectedInitialCompanyType}
                        isRepresentative={isRepresentative}
                        setIsRepresentative={setIsRepresentative}
                        isInsuranceFirm={isInsuranceFirm}
                        setIsInsuranceFirm={setIsInsuranceFirm}
                        senderFirmIntegrationCode={senderFirmIntegrationCode}
                        setSenderFirmIntegrationCode={setSenderFirmIntegrationCode}
                        receiverFirmIntegrationCode={receiverFirmIntegrationCode}
                        setReceiverFirmIntegrationCode={setReceiverFirmIntegrationCode}
                    />

                    <AccountingInformation
                        abnNumber={abnNumber}
                        mernisNo={mernisNo}
                        accountingInformationRef={accountingInformationRef}
                        selectedCommercialType={selectedCommercialType}
                        selectedEArchiveSendType={selectedEArchiveSendType}
                        selectedEArchiveType={selectedEArchiveType}
                        selectedInvoiceCurrencyType={selectedInvoiceCurrencyType}
                        selectedMaturityPeriod={selectedMaturityPeriod}
                        selectedPaymentType={selectedPaymentType}
                        setAbnNumber={setAbnNumber}
                        setMernisNo={setMernisNo}
                        setSelectedCommercialType={setSelectedCommercialType}
                        setSelectedEArchiveSendType={setSelectedEArchiveSendType}
                        setSelectedEArchiveType={setSelectedEArchiveType}
                        setSelectedInvoiceCurrencyType={setSelectedInvoiceCurrencyType}
                        setSelectedMaturityPeriod={setSelectedMaturityPeriod}
                        setSelectedPaymentType={setSelectedPaymentType}
                        setTaxOffice={setTaxOffice}
                        setTckn={setTckn}
                        setVkn={setVkn}
                        taxOffice={taxOffice}
                        tckn={tckn}
                        vkn={vkn}
                        canBeEdited={canBeEdited}
                        isWithholding={isWithholding}
                        setIsWithholding={setIsWithholding}
                    />

                    <AddressInformation
                        addressInformationRef={addressInformationRef}
                        companyAddresses={companyAddresses}
                        setCompanyAddresses={setCompanyAddresses}
                        canBeEdited={canBeEdited}
                    />

                    <AuthorizedPersonsInformations
                        authorizedPersonsInformationsRef={authorizedPersonsInformationsRef}
                        companyAuthorizedPersons={companyAuthorizedPersons}
                        setCompanyAuthorizedPersons={setCompanyAuthorizedPersons}
                        canBeEdited={canBeEdited}
                    />

                    <BanksInformations
                        banksInformationsRef={banksInformationsRef}
                        companyBanks={companyBanks}
                        setCompanyBanks={setCompanyBanks}
                        canBeEdited={canBeEdited}
                    />

                    <FileArchives
                        fileArchives={fileArchives}
                        fileArchivesRef={fileArchivesRef}
                        setFileArchives={setFileArchives}
                        canBeEdited={canBeEdited}
                    />

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">
                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button disabled={!canBeEdited} className="btn btn-primary btn-sm" onClick={saveCompany}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment >
    )
}

export default CompanyAdd;